import { useFormContext, useWatch } from 'react-hook-form';

// useWatch's result is optimised for render phase instead of useEffect's deps, to detect value updates you may want to use an external custom hook for value comparison. See https://react-hook-form.com/docs/usewatch for more details
export const useFormValues = <T>() => {
    const { getValues } = useFormContext<T>();

    return {
        ...useWatch(), // subscribe to form value updates
        ...getValues(), // always merge with latest form values
    };
};
